import axios from 'axios'
import qs from 'qs';
import {Loading, Message} from 'element-ui';
import store from '@/store/store'
import {Promise} from "es6-promise";
import Vue from 'vue'

Vue.prototype.$message = Message;

const baseURL =  process.env.NODE_ENV == 'development' ? 'https://dev.gbozo.leungsiuyin.top/api' : 'https://app.zocentive.com/api';
// const baseURL = 'https://gbozo.maxionweb.com/api';
// const baseURL = 'http://120.25.226.182:8000/api';
// request api
axios.defaults.withCredentials = true;
const request = new axios.create({
  baseURL: baseURL
});

const myRequest = (method, url, body = {}, json = false) => {
  return new Promise(resolve => {
    let headers = {token: store.getters.getToken};
    if (json) {
      headers['Content-Type'] = 'application/json;charset=utf-8'
    }
    if (method === 'POST') {
      request.post(url, json ? JSON.stringify(body) : qs.stringify(body), {
        headers: headers
      }).then(res => {
        resolve(res)
      }).catch(() => {
            Message.error('Error');
            hideLoading()
          }
      )
    } else if (method === 'GET') {
      request.get(url, {params: body, headers: headers}).then(res => {
        resolve(res)
      }).catch(() => {
            Message.error('Error');
            hideLoading()
          }
      )
    }

  })
};

// loading toast
const showLoading = (text) => {
  Loading.service({
    lock: true,
    text: text,
    spinner: 'el-icon-loading',
    background: 'rgba(250, 250, 250, 0.4)',
    customClass: 'customer-loader'
  });
};

const hideLoading = () => {
  Loading.service().close()
};

const adjustArrayOrder = (index, arr, type) => {
  let _arr = [...arr];
  if (type === 'up' && index !== 0) {
    let add_item = _arr.splice(index, 1)[0];
    _arr.splice(index - 1, 0, add_item);
  } else if (type === 'down' && index !== arr.length - 1) {
    let add_item = _arr.splice(index, 1)[0];
    _arr.splice(index + 1, 0, add_item);
  }
  let start_index = 1;
  _arr = _arr.map(v => {
    v.order = start_index;
    start_index++;
    return v
  });
  return _arr
};

const arraysLoop = (arr, holder = [],counter=[]) => {
  if (arr.length === 0) {
    return holder.map((v,i) => {
      return {
        options:v.split('&&'),
        stock:1,
        price:0,
        combine:counter[i]
      }
    })
  }
  let _holder = arr[0].length !== 0?[]:holder;
  let _counter = arr[0].length !== 0?[]:counter;
  if (holder.length === 0 && arr[0].length !== 0) {
    arr[0].forEach((v,i) => {
      _holder.push(v);
      _counter.push(`${i}`)
    })
  } else if (arr[0].length !== 0) {
    holder.forEach((v,i) => {
      arr[0].forEach((_v,_i) => {
        _holder.push(`${v}&&${_v}`);
        _counter.push(`${counter[i]}${_i}`)
      })
    })

  }
  arr.shift();
  return arraysLoop(arr,_holder,_counter)
};

export {baseURL, myRequest, showLoading, hideLoading, adjustArrayOrder, arraysLoop}